import { Checkbox, CheckboxGroup, Description, Label } from '@heroui/react';

export interface FilterCheckboxOption {
  value: string;
  label: string;
}

interface FilterCheckboxGroupProps {
  label: string;
  description?: string;
  options: FilterCheckboxOption[];
  selected: string[];
  onChange: (selected: string[]) => void;
  requireAtLeastOne?: boolean;
}

export function FilterCheckboxGroup({
  label,
  description,
  options,
  selected,
  onChange,
  requireAtLeastOne = false,
}: FilterCheckboxGroupProps) {
  return (
    <section className="flex flex-col gap-3">
      <div className="flex flex-col gap-1">
        <Label className="text-sm font-semibold">{label}</Label>
        {description ? <Description>{description}</Description> : null}
      </div>
      <CheckboxGroup
        variant="secondary"
        className="flex flex-col gap-2 [&_[data-slot=checkbox]]:mt-0"
        aria-label={label}
        value={selected}
        onChange={(values) => {
          const next = [...values];
          if (requireAtLeastOne && next.length === 0) return;
          onChange(next);
        }}
      >
        {options.map((option) => (
          <Checkbox key={option.value} value={option.value}>
            <Checkbox.Content>
              <Checkbox.Control>
                <Checkbox.Indicator />
              </Checkbox.Control>
              {option.label}
            </Checkbox.Content>
          </Checkbox>
        ))}
      </CheckboxGroup>
    </section>
  );
}
